import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=206ef96c&scoped=true&functional=true"
var script = {}
import style0 from "./Step2.vue?vue&type=style&index=0&id=206ef96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "206ef96c",
  null
  
)

export default component.exports